export const BASE_ENDPOINT_VAI_E_VEM = '/api/vai-e-vem';
export const BASE_ENDPOINT_ENQUETES = '/api/enquetes';

export const ENDPOINTS = {
  projetos: '/projetos/',
  clubes: '/clubes/',
  atletas: '/atletas/',
  status: '/status/',
  transacao: '/transacoes/',
};



// WEBPACK FOOTER //
// local_static/templates/vai_vem/2018/assets/scripts/api/endpoints.js